import React, { useContext, useState } from 'react'
import Layout from 'shared/layouts/Main'
import { Button, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { roles } from 'consts'
import hasAnyRole from 'shared/utils/hasAnyRole'
import InputWrapper from 'shared/components/InputWrapper'
import resFilterValuesNotification from './resolvers/resFilterValuesNotification'
import useInit from './hooks/useInit'
import useFocusError from 'shared/hooks/useFocusError'
import submitForm from './utils/submitForm'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import prepareSubmitForm from './utils/prepareSubmitForm'
import { ReactReduxContext } from 'react-redux'
import LayoutSwitcher from 'components/LayoutSwitcher'

const FilterValuesNotification: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [dataLoaded, setDataLoaded] = useState<boolean>(false)

  const submitRef = React.createRef<HTMLButtonElement>()

  const [currentCustomer, setCurrentCustomer] = useState<{} | null>({})

  const { store } = useContext(ReactReduxContext)

  const {
    handleSubmit,
    setFocus,
    reset,
    setError,
    register,
    getValues,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: resFilterValuesNotification,
    defaultValues: { email: null },

  })

  useInit({
    setDataLoaded,
    setShowOverlay,
    reset,
    currentCustomer
  })

  useFocusError({
    errors,
    setFocus,
  })

  const isAdmin: boolean = hasAnyRole([roles.admin, roles.superAdmin])

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showOverlay={showOverlay}
      showCardHeader={true}
      actionInsert={
        isAdmin && (
          <Button
            disabled={!dataLoaded}
            type='submit'
            name='save'
            className='btn-round btn-primary'
            onClick={() => {
              if (submitRef.current != null) {
                submitRef.current.click()
              }
            }}
          >
            Save
          </Button>
        )
      }
      menuBottomInsert={hasAnyRole([roles.superAdmin]) ? <LayoutSwitcher store={store} /> : false}
    >
      <Form
        onSubmit={handleSubmit((data) =>
          prepareSubmitForm({
            submitForm,
            setError,
            data,
            setShowOverlay,
            name: 'Filter Values Nofitication Email',
          }),
        )}
        id='main-form'
      >
        <InputWrapper label='Email' name='email' errors={errors}>
          <Form.Control type='email' {...register('email')} />
            <div className="form-text">
              Please fill in the recipient's email address for the newly synchronized Filter Values.
            </div>
        </InputWrapper>
        <Button type='submit' name='save' ref={submitRef} className='d-none'></Button>
      </Form>
    </Layout>
  )
}

export default FilterValuesNotification
